import { render, staticRenderFns } from "./policy_area.vue?vue&type=template&id=3b56dde1&scoped=true"
import script from "./policy_area.vue?vue&type=script&lang=js"
export * from "./policy_area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b56dde1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b56dde1')) {
      api.createRecord('3b56dde1', component.options)
    } else {
      api.reload('3b56dde1', component.options)
    }
    module.hot.accept("./policy_area.vue?vue&type=template&id=3b56dde1&scoped=true", function () {
      api.rerender('3b56dde1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/rebate/rebate_policy/form/components/policy_area.vue"
export default component.exports